import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';
import cPdtList from './cPdtList';

export default class iPdtList extends cPdtList {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

  $id_stgs = { // 子で上書き
    cLoadCnd: () => {
      if (global.c?.state.sgcd_pageCmns?.userc410 == '80') {
        let _cnd = bf.q('[cm50b11k]="{}"'.f(
          global.c?.state.sgcd_pageCmns?.cm20_key,
        ));
        return _cnd;
      }
      else {
        let _cnd = bf.q('[cm50b11k]="{}" AND IFNULL([cm50cz10],"10")<>"0"'.f(
          global.c?.state.sgcd_pageCmns?.cm20_key,
        ));
        return _cnd;
      };
    },
  };

//        b_rhtVsb={true}

  render() {
//        b_rhtVsb={bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80']) ? true : false}
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_sch={false}
        onSchEnt={null}
        b_rhtVsb={bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80']) ? true : false}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          let _d_pageInfs = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageName: 'iPdtDtl',
            sgc_pageMode: 'new',
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        n_bdyW={ic.gn_w}
        d_hdrs={{
          pfx: iv._get_hdrPfx('商品一覧'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            ld_iss: [
              ip.dd_rptss['商品一覧CSV'],
            ],
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
//              state: 'sld_cm50ss',
              state: 'sld_cm50ss',
              nextRole: global.c?.state.sgc_pageRole,
              nextPage: 'iPdtDtl',
              nextMode: 'show',
              keyName: 'cm50_key',
              b_edt: false,
              b_img: false,
              b_bdr: false,
            }
          ]
        }}
      />
    );
  }

};
